<!--
  - Copyright (c) 2019 brightlamp
  -->

<template>
    <div>
        <v-progress-linear v-if="waiting" :indeterminate="true"/>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'

    export default
    {
        name: 'mrn-results-export',
        async mounted()
        {
            try
            {
                this.HIDE_SNACKBAR();
                this.WAITING(true);
                await this.GET_RESULT_DATA({guid: this.$route.params['guid']});
                window.location = this.resultData['reportUrl'];
            }
            catch (error)
            {
                this.SHOW_SNACKBAR_ERROR(error.message);
            }
            this.WAITING(false)
        },
        computed:
        {
            ...mapState('exportResult',
            {
                resultData: state => state.resultData
            }),
            ...mapState('common',
            {
                waiting: state => state.waiting
            })
        },
        methods:
        {
            ...mapActions('exportResult', ['GET_RESULT_DATA']),
            ...mapMutations('common', ['WAITING', 'SHOW_SNACKBAR_ERROR', 'HIDE_SNACKBAR']),
        }
    }

</script>

<style scoped>

</style>